export const TAG_LIST_INPUT = {
  INVALID_EMAIL_ADDRESS: { key: 'INVALID_EMAIL_ADDRESS', value: 'Invalid email address. Please type a valid email address.' },
  TYPE_EMAIL_PLACEHOLDER: { key: 'TYPE_EMAIL_PLACEHOLDER', value: 'Type the email id and press enter to add' },
};
